import { CampaignMaterialsController } from './campaign-materials.controller'

function campaignMaterials () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-materials/campaign-materials.html?$$REVISION$$',
    controller: CampaignMaterialsController
  }
}

export { campaignMaterials }
